var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{class:{fullScreen: _vm.fullScreen},attrs:{"styling":!!_vm.msg}},[_c('div',{staticClass:"loader flex column gap10 align-center"},[_c('img',{staticClass:"preview",attrs:{"src":require('@/assets/images/loader.gif')}}),(_vm.msg)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.msg)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }